import { EventEmitter, Injectable, QueryList } from '@angular/core';
import { VgUtils } from './vg-utils';
import { VgMedia } from '../vg-media/vg-media';
import { Subscription ,  Observable } from 'rxjs';

@Injectable()
export class VgSeekBarApi {

    private onStartSeek: EventEmitter<any> = new EventEmitter();
    private onEndSeek: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    public subscript(key,subs)
    {
        if (key == "seekstart")
        {
            return this.onStartSeek.subscribe(subs);
        }
        else
        {
            return this.onEndSeek.subscribe(subs);
        }
    }

    public notify(key)
    {
        if (key == "seekstart") {
            this.onStartSeek.next(true);
        }
        else {
            this.onEndSeek.next(true);
        }
    }
 
}
